<template>
  <div>
    <ed-absenteismo :intAbsenteismoId="0" :key="$root.$session.versao"/>
  </div>
</template>

<script>
import EdAbsenteismo from "@/components/absenteismo/editar";

export default {
  name: "pageCadastroEmpresa",
  props: {},
  components: {EdAbsenteismo },
  mounted() {},
  created() {},
  data() {
    return {
    };
  },
  methods: {
  
  },
};
</script>